<template>
  <div v-if="curricula.length === 0">
    <p>{{ $t("components.InstitutionCurricula.info") }}</p>
  </div>
  <div v-else>
    <v-row v-for="curriculum in curricula" :key="curriculum.slug">
      <v-col cols="12">
        <h3>
          {{ $t(`curriculums.${curriculum.slug}.title`) }}
        </h3>
        <v-list v-for="(subjectGroup) in curriculum.subjectGroups" :key="subjectGroup.slug">
          <v-list-item>
            <v-list-item-title>
              {{ $t(`curriculums.${curriculum.slug}.subject_groups.${subjectGroup.slug}`) }}
            </v-list-item-title>
            <p v-if="subjectGroup.subjects.length === 0">
              {{ $t("components.InstitutionCurricula.alert_no_subjects") }}</p>
            <v-chip v-for="(subject) in subjectGroup.subjects" :key="subject.slug" class="mx-2">
              {{ $t(`curriculums.${curriculum.slug}.subjects.${subject.slug}`) }}
            </v-chip>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </div>

</template>

<script setup lang="ts">
import {PropType} from "vue";

defineProps(
  {
    curricula: {
      type: Object as PropType<{
        slug: string;
        enabled: boolean;
        subjectGroups: {
          slug: string;
          enabled: boolean;
          subjects: {
            slug: string;
            enabled: boolean;
          }[];
        }[];
      }[]>,
      required: true
    }
  }
);
</script>

<style scoped>

</style>
